/**
 * Checks if the current browser URL matches the enrollment page pattern (without module)
 * @returns Boolean indicating if the current URL matches the pattern, and optionally the specific ID if provided
 */
export function isEnrollmentsPageUrl(): boolean {
  const url = window.location.pathname;

  // Create a regex pattern to match the URL structure for enrollment page (without module)
  const pattern = /\/enrollments\/(\d+)$/;
  const match = url.match(pattern);

  return !!match;
}
